import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { NextCloudLink } from '../types';

export const getProductLinkNextCloud = async (
  qnapDirectory: string,
  woUid: string
): Promise<NextCloudLink> => {
  const fetchResponse = await fetch(
    `${
      env.VITE_API_URL
    }/pb/s/api/sqo-portal/auditor-visits/products-nextcloud/directory/${qnapDirectory}?${new URLSearchParams(
      {
        woUid,
      }
    )}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as NextCloudLink;

  if (!response.status) {
    throw new ApiError({ message: response.message } as ErrorResponseDto);
  }
  return response;
};
